import Reflux from 'reflux';
import BaseMixin from 'flux/stores/BaseMixin';
import EventViewMixin from 'flux/stores/EventViewMixin';
import EventViewActions from 'flux/actions/EventViewActions';
import EventActions from 'flux/actions/EventActions';
import RealTimeActions from 'flux/actions/RealTimeActions';
import { fromJS } from 'immutable';

/**
 * EventViewStore
 *
 */
export default Reflux.createStore({
  listenables: [EventViewActions, EventActions, RealTimeActions],

  mixins: [BaseMixin, EventViewMixin],

  onPopulateForGuestCompleted(event) {
    // In support of https://github.com/SHOFLO/Issues/issues/5086 ...
    // This has the effect of hiding the event title when it's a template container event
    if (event.globalTemplateContainer) {
      event.title = '';
    }
    this.setStateAndTrigger(fromJS(event));
  },
});
